var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.014,
    height: 8.476,
    viewBox: "0 -2 14.014 8.476",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.304-1.296L7.007 5.056.71-1.296",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })));
}
export default SvgIconDown;